/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Guide_How_It_Works_DescriptionInputs */

const en_directory_guide_how_it_works_description = /** @type {(inputs: Directory_Guide_How_It_Works_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seek AI reviews submissions before they appear in the directory. Once published, you can manage your listing from My tools.`)
};

const zh_directory_guide_how_it_works_description = /** @type {(inputs: Directory_Guide_How_It_Works_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seek AI 会在产品进入目录前审核提交内容。发布后，你可在「我的产品」中管理该页面。`)
};

/**
* | output |
* | --- |
* | "Seek AI reviews submissions before they appear in the directory. Once published, you can manage your listing from My tools." |
*
* @param {Directory_Guide_How_It_Works_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_guide_how_it_works_description = /** @type {((inputs?: Directory_Guide_How_It_Works_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Guide_How_It_Works_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_guide_how_it_works_description(inputs)
	return zh_directory_guide_how_it_works_description(inputs)
});
export { directory_guide_how_it_works_description as "directory.guide.how_it_works.description" }